<template>
  <div>
    <b-row class="align-items-end">
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <SearchTextInput
          v-model="searchTicketIdValue"
          label="Search Case No."
          placeholder="Search Case No."
          @keyup.enter.native="fetchFilter()" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <SearchTextInput
          v-model="searchSubjectValue"
          label="Search Subject"
          placeholder="Search Subject"
          @keyup.enter.native="fetchFilter()" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <FilterMultipleSelect
          v-model="searchUserGroupValue"
          label="Group"
          placeholder="Group"
          label-option="name"
          return-value="id"
          :options="userGroup"
          @input="fetchFilter()" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <FilterDropdown
          v-model="searchIncidentValue"
          label="Case Type"
          placeholder="Case Type"
          label-option="name"
          return-value="id"
          :options="ticketType"
          @input="fetchFilter()" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <FilterDropdown
          v-model="searchPriorityValue"
          label="Priority"
          placeholder="Priority"
          label-option="label"
          return-value="value"
          :options="priorityOption"
          @input="fetchFilter()" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <DatePickerFilter
          v-model="startDateValue"
          label="Start Date" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <DatePickerFilter
          v-model="endDateValue"
          label="End Date" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <SearchTextInput
          v-model="searchCustomerNameValue"
          label="Search Customer Name"
          placeholder="Search Customer Name"
          @keyup.enter.native="fetchFilter()" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <SearchTextInput
          v-model="searchPhoneNumberValue"
          label="Search Phone Number"
          placeholder="Search Phone Number"
          @keyup.enter.native="fetchFilter()" />
      </b-col>
      <b-col
        class="mb-1 mb-sm-0"
        sm="12"
        md="3">
        <FilterDropdown
          v-model="searchStatusValue"
          label="Status"
          placeholder="Status"
          label-option="label"
          return-value="value"
          :options="statusOptions"
          @input="fetchFilter()" />
      </b-col>
      <b-col
        sm="12"
        md="2"
        class="mb-1 mb-sm-0">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="w-100"
          variant="primary"
          @click="fetchFilter()">
          <feather-icon
            icon="SearchIcon"
            class="mr-50 mr-md-0 mr-lg-0 mr-xl-50"
          />
          <span class="align-middle">Search</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SearchTextInput from '@/components/Filter/SearchTextInput.vue'
import FilterDropdown from '@/components/Filter/FilterDropdown.vue'
import DatePickerFilter from '@/components/Filter/DatePickerFilter.vue'
import FilterMultipleSelect from '@/components/Filter/FilterMultipleSelect.vue'

export default {
  components: {
    DatePickerFilter,
    SearchTextInput,
    FilterDropdown,
    FilterMultipleSelect
  },
  props: {
    ticketType: {
      type: Array,
      default: () => ([])
    },
    userGroup: {
      type: Array,
      default: () => ([])
    },
    searchIncident: {
      type: [String, Number],
      default: null
    },
    searchPriority: {
      type: String,
      default: null
    },
    searchStatus: {
      type: String,
      default: null
    },
    searchCustomerName: {
      type: String,
      default: null
    },
    searchPhoneNumber: {
      type: String,
      default: null
    },
    searchUserGroup: {
      type: Array,
      default: () => ([])
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      incidentOptions: [
        { label: 'A', value: 'A1' },
        { label: 'B', value: 'B1' }
      ],
      priorityOption: [
        { label: 'Low', value: 'low' },
        { label: 'Medium', value: 'medium' },
        { label: 'High', value: 'high' }
      ],
      statusOptions: [
        { label: 'Open', value: 'open' },
        { label: 'Closed', value: 'closed' },
        { label: 'Void', value: 'void' },
        { label: 'Over Due', value: 'over Due' }
      ]
    }
  },
  computed: {
    searchIncidentValue: {
      get () {
        return this.searchIncident
      },
      set (val) {
        this.$emit('update:search-incident', val)
      }
    },
    searchPriorityValue: {
      get () {
        return this.searchPriority
      },
      set (val) {
        this.$emit('update:search-priority', val)
      }
    },
    searchStatusValue: {
      get () {
        return this.searchStatus
      },
      set (val) {
        this.$emit('update:search-status', val)
      }
    },
    searchCustomerNameValue: {
      get () {
        return this.searchCustomerName
      },
      set (val) {
        this.$emit('update:search-customer-name', val)
      }
    },
    searchPhoneNumberValue: {
      get () {
        return this.searchPhoneNumber
      },
      set (val) {
        this.$emit('update:search-phone-number', val)
      }
    },
    searchUserGroupValue: {
      get () {
        return this.searchUserGroup
      },
      set (val) {
        this.$emit('update:search-user-group', val)
      }
    },
    searchTicketIdValue: {
      get () {
        return this.searchTicketId
      },
      set (val) {
        this.$emit('update:search-ticket-id', val)
      }
    },
    searchSubjectValue: {
      get () {
        return this.searchSubject
      },
      set (val) {
        this.$emit('update:search-subject', val)
      }
    },
    startDateValue: {
      get () {
        return this.startDate
      },
      set (val) {
        this.$emit('update:start-date', val)
      }
    },
    endDateValue: {
      get () {
        return this.endDate
      },
      set (val) {
        this.$emit('update:end-date', val)
      }
    }
  },
  methods: {
    fetchFilter () {
      this.$emit('fetch-filter')
    }
  }
}
</script>

<style>

</style>
